import { Inject, Injectable } from '@angular/core';
import { PresentationPage } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { DefaultRessourceStore } from '@shared/services/stores/default-ressource-store.service';

@Injectable()
export class PresentationPageStore extends DefaultRessourceStore<PresentationPage> {
    constructor(@Inject(getCrudName(PresentationPage)) protected crudService: GenericCrudService<PresentationPage>) {
        super(crudService, {});
    }

    protected getProjection(): string { return undefined; }
}